import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Outlet, useOutletContext } from 'react-router-dom'

import { Box, Tabs } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { RouteContext } from 'modules/employees/lib/types'
import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'
import { useReview } from 'modules/reviews/hooks/useReview'

type Tab = {
  href: string
  name: string
}

const EmployeeReviewPage = () => {
  const params = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const { loading, review } = useReview(params.review_id)
  const { navigation } = useNavigation()
  const { hasPerformanceFullVisiblity } = useOutletContext<RouteContext>()

  if (loading) return <Loading />
  if (!review) return <NotFound />

  const employeeId = Number(params.id)
  const name = review ? review.attributes.name : i18n.t('common.review')

  const tabs: Tab[] = [
    {
      href: navigation.employees.id.reviews.reviewId.answers.fullPath({
        id: employeeId,
        review_id: review.id,
      }),
      name: i18n.t('surveys.form.tabs.answers'),
    },
  ]

  if (hasPerformanceFullVisiblity || review.isFinished) {
    tabs.push({
      href: navigation.employees.id.reviews.reviewId.analytics.fullPath({
        id: employeeId,
        review_id: review.id,
      }),
      name: i18n.t('surveys.form.tabs.analytics'),
    })
  }

  const currentTabId = tabs.find((tab) => pathname.includes(tab.href))?.href || pathname

  return (
    <Page
      isLoading={loading}
      notFound={{
        active: !review,
        title: i18n.t('errors.page_not_found.title'),
        description: i18n.t('errors.page_not_found.description'),
      }}
    >
      <Page.Header>
        <Header.Title backTo={navigation.employees.id.reviews.fullPath({ id: employeeId })}>
          {name}
        </Header.Title>
      </Page.Header>
      <Page.Body size="wide">
        <Tabs currentId={currentTabId} onTabClicked={navigate}>
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.href} id={tab.href} label={tab.name} />
          ))}
        </Tabs>
        <Box paddingTop="s32">
          <Outlet context={{ review }} />
        </Box>
      </Page.Body>
    </Page>
  )
}

export default EmployeeReviewPage
